import { Reducer } from 'redux';
import { FundraisingModel, FundraisingModelList } from 'src/models/FundraisingModel';
import {
  ADD_FUNDRAISING, REMOVE_FUNDRAISING,
} from 'src/redux/actions/fundraisingAction';

export type FundraisingListState = FundraisingModelList;

const DEFAULT = {} as FundraisingListState;

const FundraisingsReducer: Reducer<FundraisingListState> = (state = DEFAULT, action) => {
  switch (action.type) {
    case ADD_FUNDRAISING: {
      const { id, fundraising } = action.payload;
      return {
        ...state,
        [id]: fundraising as FundraisingModel,
      };
    }
    case REMOVE_FUNDRAISING: {
      const id = action.payload;
      const { [id]: removedFundraising, ...remainingFundraising } = state;
      return {
        ...remainingFundraising,
      };
    }
    default:
      return state;
  }
};

export default FundraisingsReducer;
